/**************************************************
 * Nombre:       Dialogo_Politica
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const Dialogo_Politica = ({datos}) => {

    const htmlFrom = (htmlString) => {
        const cleanHtmlString = DOMPurify.sanitize(htmlString,
            {USE_PROFILES: {html: true}});
        const html = parse(cleanHtmlString);
        return html;
    }


    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                {htmlFrom(datos?.textoEstilo)}
            </Grid2>

        </Grid2>
    )

}
export default Dialogo_Politica